import { render, staticRenderFns } from "./InvitacionesComponent.vue?vue&type=template&id=e6c9e65c"
import script from "./InvitacionesComponent.vue?vue&type=script&lang=js"
export * from "./InvitacionesComponent.vue?vue&type=script&lang=js"
import style0 from "./InvitacionesComponent.vue?vue&type=style&index=0&id=e6c9e65c&prod&scooped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports